<template>

    <v-navigation-drawer app v-model="drawer" class="white lighten-2" light disable-resize-watcher>
      <template v-for="(item, index) in items">
        <v-list-tile :key="index">
          <v-list-tile-content>{{item.title}}</v-list-tile-content>
        </v-list-tile>
        <v-divider :key="`divider-${index}`"></v-divider>
      </template>
    </v-navigation-drawer>
</template>

<script>
export default {
  name: "NavigationDrawer",
  data() {
    return {
      appTitle: "Meal Prep",
      drawer: false,
      items: [
        { title: "القائمة" },
        { title: "تسجيل الدخول" },
        { title: "التسجيل" }
      ]
    };
  }
};
</script>

<style scoped>
</style>